import React from 'react'
import { Route, Link } from 'react-router-dom'
import axios from 'axios'
import Show from './../components/show'

class Shows extends React.Component {
	constructor(props){
		super(props)

		this.state = {
			items: []
		}
	}

	componentDidMount(){
		this.fetchData()
	}

	fetchData(){
		axios.get('https://dhsetheatre-api.madebypeppernet.com/api-admin.php', {
			params: {
				filename: 'shows'
			}
		}).then( response => {
			// Filter out the items to only those with performance dates in the past.
			this.setState({
				items: response.data.items.filter( show => {
					let isComingSoon = false
					show.performance_dates && show.performance_dates.forEach( performance_date => {
						isComingSoon = false
						let d = new Date()
						let show_date = new Date(performance_date.date)
						show_date = new Date(show_date.getTime() - show_date.getTimezoneOffset() * -60000)

						if(d > show_date){
							isComingSoon = true
						}
					})
					return isComingSoon
				}).sort( (a,b) => {
					if(a.performance_dates && b.performance_dates){
						if(a.performance_dates[0].date < b.performance_dates[0].date){
							return 1
						}
						if(a.performance_dates[0].date > b.performance_dates[0].date){
							return -1
						}
						return 0
					}
					return 0
				})
			})
		})
	}

	render() {
		return (
			<section className="shows container">
				<h2>Past Shows</h2>

				<Route exact path="/shows" component = { (props) => {
					return (
						<div className="grid">
							{this.state.items.map( (item) => {
								return (
									<Link className="thumb" key={item.id} to={`${this.props.match.url}/${item.id}`}>
										<img src={decodeURIComponent(item.thumb)} alt={decodeURIComponent(item.title)} />
										<h3>{decodeURIComponent(item.title)}</h3>
									</Link>
									)
							})}
						</div>
					)
				}} />

				<Route path={`${this.props.match.url}/:showId`} component={ (props) => {
					return <Show id={`${props.match.params.showId}`} />
				}} />
			</section>
		)
	}
}

export default Shows



// WEBPACK FOOTER //
// ./src/pages/shows.js